import { Link } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { bannerApi } from '../api/services';
import './HomePage.css';

export default function HomePage() {
  const { data: banners } = useQuery({
    queryKey: ['banners'],
    queryFn: () => bannerApi.getActive().then((r) => r.data),
  });

  return (
    <div className="home-page">
      {/* Hero */}
      <section className="hero-section">
        <div className="hero-bg-shapes">
          <div className="shape shape-1" />
          <div className="shape shape-2" />
          <div className="shape shape-3" />
        </div>
        <div className="container hero-content">
          <div className="hero-badge">🚀 Hızlı Teslimat</div>
          <h1 className="hero-title">
            Lezzetli Yemekler &<br />
            <span className="hero-gradient">Market Alışverişi</span>
          </h1>
          <p className="hero-desc">
            Tek platformdan yemek sipariş et, market ihtiyaçlarını karşıla.<br />
            Hızlı teslimat, sorunsuz ödeme.
          </p>

          {/* Main Cards */}
          <div className="service-cards">
            <Link to="/food" className="service-card service-card-food">
              <div className="service-card-icon">🍔</div>
              <div className="service-card-body">
                <h2>Yemek Siparişi</h2>
                <p>Pizza, burger, döner ve daha fazlası</p>
              </div>
              <div className="service-card-arrow">→</div>
              <div className="service-card-glow" />
            </Link>

            <Link to="/market" className="service-card service-card-market">
              <div className="service-card-icon">🛒</div>
              <div className="service-card-body">
                <h2>Market Siparişi</h2>
                <p>Meyve, sebze, temizlik ve daha fazlası</p>
              </div>
              <div className="service-card-arrow">→</div>
              <div className="service-card-glow" />
            </Link>
          </div>
        </div>
      </section>

      {/* Banners */}
      {banners && banners.length > 0 && (
        <section className="banners-section">
          <div className="container">
            <div className="banners-grid">
              {banners.map((banner: any) => (
                <div key={banner.id} className="banner-card">
                  {banner.imageUrl ? (
                    <img src={banner.imageUrl} alt={banner.title} />
                  ) : (
                    <div className="banner-content">
                      <span className="banner-emoji">🎉</span>
                      <div>
                        <h3>{banner.title}</h3>
                        {banner.subTitle && <p>{banner.subTitle}</p>}
                      </div>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </section>
      )}

      {/* Features */}
      <section className="features-section">
        <div className="container">
          <div className="features-grid">
            {[
              { icon: '⚡', title: 'Hızlı Teslimat', desc: 'Ortalama 30-45 dakika içinde kapınızda' },
              { icon: '💳', title: 'Güvenli Ödeme', desc: 'Nakit, kredi kartı ve çek senetleri' },
              { icon: '📍', title: 'Canlı Takip', desc: 'Siparişinizi anlık olarak takip edin' },
              { icon: '🎁', title: 'Kampanyalar', desc: 'Özel indirimler ve kuponlar' },
            ].map((f) => (
              <div key={f.title} className="feature-card">
                <div className="feature-icon">{f.icon}</div>
                <h3>{f.title}</h3>
                <p>{f.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
